export default __webpack_public_path__ + "static/media/2.a9ec7062.svg";